<app-page-title icon="fa-line-chart" title="Performance por Funil">
  <a href="/#/analytics" class="btn-back" title="Voltar para Analytics">
    <i class="fa fa-arrow-left"></i> Voltar
  </a>
</app-page-title>

<div class="app-analytics funnel-performance">
  <!-- Filtros -->
  <div class="filters-bar">
    <div class="filters-row">
      <div class="fast-filter">
        <button class="filter-chip" *ngFor="let filter of fastFilters"
                [class.active]="filter.id === fastFilter"
                (click)="applyFastFilter(filter.id)">{{ filter.text }}</button>
      </div>
      <div class="date-range-antd" (click)="rangePicker.open()">
        <div class="date-range-input">
          <span class="date-range-value">{{ startDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <span class="date-range-separator">
          <i class="fa fa-arrow-right"></i>
        </span>
        <div class="date-range-input">
          <span class="date-range-value">{{ endDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <i class="fa fa-calendar date-range-icon"></i>
        <mat-date-range-input [rangePicker]="rangePicker" class="date-range-hidden">
          <input matStartDate [(ngModel)]="startDate" (dateChange)="fastFilter = null">
          <input matEndDate [(ngModel)]="endDate" (dateChange)="fastFilter = null">
        </mat-date-range-input>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
      </div>
    </div>
    <div class="filters-row mt-2">
      <div class="integration-filter">
        <select name="integration" id="integration" class="form-control" [(ngModel)]="integrationId">
          <option value="0">Todas as integracoes</option>
          <option *ngFor="let integration of integrations" [value]="integration.id">
            {{ integration.name }}
          </option>
        </select>
      </div>
      <div class="filter-actions">
        <button class="btn btn-primary" (click)="applyFilter()">
          <i class="fa fa-search"></i>
        </button>
        <button class="btn btn-secondary ms-2" (click)="clearFilter()">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <small class="text text-danger d-block mt-1" *ngIf="startDate && endDate && startDate > endDate">Periodo invalido.</small>
  </div>

  <div *ngIf="loading" style="min-height: 60vh;">
    <app-skeleton variant="card" [count]="3" label="Carregando o desempenho do funil"></app-skeleton>
    <app-skeleton variant="table-row" [count]="8" [columns]="5" label=""></app-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <!-- KPI Dashboard: 3 colunas -->
    <div class="row g-3 mt-1">
      <!-- Coluna 1: Receita Total + 3 mini-cards -->
      <div class="col-12 col-md-3 d-flex flex-column gap-3">
        <app-analytics-card
          title="Receita Total"
          autoHeight="true"
          highlightText="{{ totals.total_revenue | numberFormat: 'R$ ' : true }}"
          tooltipText="Receita total atribuida as campanhas de automacao SMS no periodo selecionado.">
        </app-analytics-card>
        <app-analytics-card
          title="Receita Total SMS"
          autoHeight="true"
          highlightText="{{ totals.total_sms_revenue | numberFormat: 'R$ ' : true }}"
          tooltipText="Receita total recuperada pelos funis SMS no periodo selecionado.">
        </app-analytics-card>
        <app-analytics-card
          title="Custo Total"
          autoHeight="true"
          highlightText="{{ totals.total_cost | numberFormat: 'R$ ' : true }}"
          tooltipText="Custo total com envio de SMS no periodo (quantidade enviada x custo unitario por SMS).">
          <div class="badgeds badge-right">
            <span class="badge badge-info">{{ totals.sms_unit_cost | numberFormat: 'R$ ' : true }} / SMS</span>
          </div>
        </app-analytics-card>
        <app-analytics-card
          title="Total de Conversoes SMS"
          autoHeight="true"
          highlightText="{{ totals.total_sms_conversions | number }}"
          tooltipText="Total de conversoes atribuidas aos funis SMS no periodo selecionado.">
        </app-analytics-card>
      </div>

      <!-- Coluna 2: ROI TOTAL SMS -->
      <div class="col-12 col-md-3 d-flex">
        <div class="roi-card w-100">
          <div class="roi-label">ROI TOTAL SMS</div>
          <div class="roi-value">{{ totals.total_sms_roi | number: '1.1-2' }}x</div>
          <div class="roi-subtitle">Retorno sobre investimento</div>
          <div class="roi-breakdown">
            <div class="roi-breakdown-item">
              <span class="roi-breakdown-label">Receita</span>
              <span class="roi-breakdown-value">{{ totals.total_sms_revenue | numberFormat: 'R$ ' : true }}</span>
            </div>
            <div class="roi-breakdown-item">
              <span class="roi-breakdown-label">Custo</span>
              <span class="roi-breakdown-value">{{ totals.total_sms_cost | numberFormat: 'R$ ' : true }}</span>
            </div>
            <div class="roi-breakdown-item">
              <span class="roi-breakdown-label">Lucro</span>
              <span class="roi-breakdown-value profit">{{ totals.total_sms_revenue - totals.total_sms_cost | numberFormat: 'R$ ' : true }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna 3: 2 cards em cima + Distribuicao de Receita embaixo -->
      <div class="col-12 col-md-6 d-flex flex-column gap-3">
        <div class="row g-3">
          <div class="col-12 col-sm-6">
            <app-analytics-card
              title="Total de Conversoes"
              highlightText="{{ totals.total_conversions | number }}"
              tooltipText="Total de vendas atribuidas a mensagens enviadas pelas campanhas de automacao.">
            </app-analytics-card>
          </div>
          <div class="col-12 col-sm-6">
            <app-analytics-card
              title="Total SMS Enviados"
              highlightText="{{ totals.total_sms_sent | number }}"
              tooltipText="Total de mensagens SMS disparadas pelas automacoes no periodo selecionado.">
            </app-analytics-card>
          </div>
        </div>
        <div class="section-card w-100 flex-grow-1">
          <h4 class="section-title">Distribuicao de Receita</h4>
          <apx-chart
            *ngIf="pieChartOptions"
            [series]="pieChartOptions.series"
            [chart]="pieChartOptions.chart"
            [labels]="pieChartOptions.labels"
            [colors]="pieChartOptions.colors"
            [legend]="pieChartOptions.legend"
            [dataLabels]="pieChartOptions.dataLabels"
            [plotOptions]="pieChartOptions.plotOptions"
            [tooltip]="pieChartOptions.tooltip">
          </apx-chart>
          <div *ngIf="!pieChartOptions" class="text-center text-muted py-4">
            Nenhum dado de funil no periodo selecionado.
          </div>
        </div>
      </div>
    </div>

    <!-- Linha 3: Tabela Performance por Funil com drill-down inline -->
    <div class="row mt-4">
      <div class="col-12">
        <h4 class="section-title">Performance por Funil</h4>
        <div class="section-card table-responsive">
          <table class="table table-hover mb-0" *ngIf="funnels.length; else noFunnels">
            <thead>
              <tr>
                <th></th>
                <th>Funil</th>
                <th class="text-end">SMS Enviados</th>
                <th class="text-end">Custo</th>
                <th class="text-end">Conversoes</th>
                <th class="text-end">Receita</th>
                <th class="text-end">ROI</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let funnel of funnels">
                <tr (click)="selectFunnel(funnel)"
                    class="funnel-row"
                    [class.active-row]="selectedFunnel?.campaign_id === funnel.campaign_id"
                    [class.dimmed-row]="selectedFunnel && selectedFunnel.campaign_id !== funnel.campaign_id">
                  <td class="expand-cell">
                    <i class="fa"
                       [class.fa-chevron-right]="selectedFunnel?.campaign_id !== funnel.campaign_id"
                       [class.fa-chevron-down]="selectedFunnel?.campaign_id === funnel.campaign_id"></i>
                  </td>
                  <td>
                    <strong class="funnel-name">{{ funnel.campaign_name }}</strong>
                    <br><small class="funnel-list-name">{{ funnel.lead_list_name }}</small>
                  </td>
                  <td class="text-end">{{ funnel.sms_sent | number }}</td>
                  <td class="text-end">{{ funnel.cost | numberFormat: 'R$ ' : true }}</td>
                  <td class="text-end">{{ funnel.conversions | number }}</td>
                  <td class="text-end">{{ funnel.revenue | numberFormat: 'R$ ' : true }}</td>
                  <td class="text-end">
                    <span class="roi-badge">{{ funnel.roi | number: '1.1-2' }}x</span>
                  </td>
                </tr>
                <!-- Sub-rows inline -->
                <ng-container *ngIf="selectedFunnel?.campaign_id === funnel.campaign_id">
                  <tr *ngIf="loadingSequences" class="subrow">
                    <td colspan="7" class="text-center">
                      <i class="fa fa-spinner fa-spin"></i>
                    </td>
                  </tr>
                  <tr *ngFor="let seq of selectedSequences; let i = index" class="subrow">
                    <td></td>
                    <td>
                      <span class="subrow-name">Mensagem {{ i + 1 }}</span>
                      <small class="subrow-interval">{{ seq.interval }} {{ seq.interval_type }}</small>
                    </td>
                    <td class="text-end subrow-value">{{ seq.sms_sent | number }}</td>
                    <td class="text-end subrow-value">{{ seq.cost | numberFormat: 'R$ ' : true }}</td>
                    <td class="text-end subrow-value">{{ seq.conversions | number }}</td>
                    <td class="text-end subrow-value">{{ seq.revenue | numberFormat: 'R$ ' : true }}</td>
                    <td class="text-end">
                      <span class="roi-badge roi-badge-sm">{{ seq.roi | number: '1.1-2' }}x</span>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
          <ng-template #noFunnels>
            <div class="text-center text-muted py-4">
              Nenhum funil com conversoes no periodo selecionado.
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Linha 4: UTM - Distribuição + Receita por UTM -->
    <div class="row g-3 mt-4" *ngIf="salesUtm.length">
      <div class="col-12 col-md-5">
        <div class="section-card h-100">
          <h4 class="section-title">Distribuicao por UTM</h4>
          <apx-chart
            *ngIf="utmChartOptions"
            [series]="utmChartOptions.series"
            [chart]="utmChartOptions.chart"
            [labels]="utmChartOptions.labels"
            [colors]="utmChartOptions.colors"
            [legend]="utmChartOptions.legend"
            [dataLabels]="utmChartOptions.dataLabels"
            [plotOptions]="utmChartOptions.plotOptions"
            [tooltip]="utmChartOptions.tooltip">
          </apx-chart>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="section-card h-100">
          <h4 class="section-title">Receita por UTM</h4>
          <div class="utm-bars">
            <div class="utm-bar-item" *ngFor="let utm of paginatedUtm(); let i = index">
              <div class="utm-bar-header">
                <span class="utm-bar-label">
                  <span class="utm-dot" [style.background-color]="getUtmColor(i)"></span>
                  {{ utm.utm }}
                </span>
                <span class="utm-bar-value">{{ utm.amount | numberFormat: 'R$ ' : true }}</span>
              </div>
              <div class="utm-bar-track">
                <div class="utm-bar-fill"
                     [style.width.%]="getUtmBarWidth(utm)"
                     [style.background-color]="getUtmColor(i)"></div>
              </div>
              <div class="utm-bar-meta">
                <span>{{ utm.quantity }} vendas</span>
                <span>{{ getUtmBarWidth(utm) | number: '1.1-1' }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Linha 5: Tabela ROI por UTM -->
    <div class="row mt-4" *ngIf="salesUtm.length">
      <div class="col-12">
        <h4 class="section-title">ROI por Origem (UTM)</h4>
        <div class="section-card table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>UTM Source</th>
                <th class="text-end">Faturamento</th>
                <th class="text-end">Conversoes</th>
                <th class="text-end">% Receita</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let utm of paginatedUtm(); let i = index" class="utm-table-row">
                <td>
                  <span class="utm-dot" [style.background-color]="getUtmColor(i)"></span>
                  <strong class="ms-2">{{ utm.utm }}</strong>
                  <span class="utm-tag" *ngIf="utm.utm === 'smsfunnel'">SMS Funnel</span>
                </td>
                <td class="text-end">{{ utm.amount | numberFormat: 'R$ ' : true }}</td>
                <td class="text-end">{{ utm.quantity | number }}</td>
                <td class="text-end utm-percent-badge">{{ getUtmBarWidth(utm) | number: '1.1-1' }}%</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="utm-total-row">
                <td><strong>Total</strong></td>
                <td class="text-end"><strong>{{ getUtmTotal() | numberFormat: 'R$ ' : true }}</strong></td>
                <td class="text-end"><strong>{{ getUtmTotalQuantity() | number }}</strong></td>
                <td class="text-end"><strong>100%</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="utm-pagination" *ngIf="utmTotalPages > 1">
          <button class="btn btn-sm btn-secondary" [disabled]="utmPage === 1" (click)="utmPrevPage()">
            <i class="fa fa-chevron-left"></i>
          </button>
          <span class="utm-pagination-info">{{ utmPage }} / {{ utmTotalPages }}</span>
          <button class="btn btn-sm btn-secondary" [disabled]="utmPage === utmTotalPages" (click)="utmNextPage()">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
